import React, { useState, useEffect, useCallback } from 'react';
import t from '~t';

import ViewAlert from './view/alert';
import ViewConfirm from './view/confirm';
import ViewPrompt from './view/prompt';

//Open alert
//{ variant: 'error' }
export async function Alert(message, custom = {}) {
  return DialogsContainer.openDialog('alert', { message, ...custom });
}

//Special Alert
//{ id }
export async function Error(error, custom = {}) {
  return DialogsContainer.openDialog('alert', {
    message: t.s('error'),
    description:
      error.error && t.has('server' + error.error)
        ? t.s('server' + error.error)
        : error.message,
    variant: 'error',
    ...custom,
  });
}

//Open confirm
//{ description, ok, cancel, variant }
export async function Confirm(message, custom = {}) {
  return DialogsContainer.openDialog('confirm', { message, ...custom });
}

//Open prompt
export async function Prompt(message, value = '', custom = {}) {
  return DialogsContainer.openDialog('prompt', {
    message,
    value,
    ...custom,
  });
}

//Include this component anywhere in the app once!
export default function DialogsContainer() {
  const [dialogs, setDialogs] = useState([]);

  const sendResult = useCallback((id, result = false) => {
    setDialogs((dialogs) => {
      const dialog = dialogs.find((dialog) => dialog.id == id);
      if (!dialog) return dialogs;

      dialog.callback(result);

      return dialogs.filter((dialog) => dialog.id != id);
    });
  }, []);

  useEffect(() => {
    const addDialog = ({ detail = {} }) => {
      const dialog = {
        ...detail,
        id: detail.id || new Date().getTime(),
      };

      setDialogs((dialogs) => [
        ...dialogs.filter(({ id }) => id != dialog.id),
        dialog,
      ]);
    };

    window.addEventListener('overlay-dialog', addDialog);
    return () =>
      window.removeEventListener('overlay-dialog', addDialog);
  }, []);

  if (!dialogs.length) return null;

  return dialogs.map(({ type, id, ...detail }) => {
    let Component;

    switch (type) {
      case 'alert':
        Component = ViewAlert;
        break;
      case 'confirm':
        Component = ViewConfirm;
        break;
      case 'prompt':
        Component = ViewPrompt;
        break;
    }

    return (
      <Component
        key={id}
        id={id}
        {...detail}
        sendResult={sendResult}
      />
    );
  });
}

DialogsContainer.openDialog = (type, detail) =>
  new Promise((callback) => {
    const event = new CustomEvent('overlay-dialog', {
      detail: {
        ...detail,
        type,
        callback,
      },
    });
    window.dispatchEvent(event);
  });
